export function containsWordLongerThan(name: string, length: number): boolean {
  return name.split(" ").filter((w) => w.length > length).length > 0;
}
